import fa from "element-ui/src/locale/lang/fa";

export default {
    data() {
        return {
            comment: '',
            is_reply: false,
            v_data: {},
            reply: [],
            p: 1,
            is_more: true
        }
    },

    created() {
        // this.v_data = this.data;
        if(this.data.reply.length > 2) {
            this.reply = this.data.reply.slice(0,2);
        }else {
            this.reply = this.data.reply
        }

    },

    methods: {

        getMoreReply() {
            if(this.is_more) {
                this.reply = this.data.reply;
                this.is_more = false;
            }else {
                this.reply = this.data.reply.slice(0,2);
                this.is_more = true;
            }
        },

        sendReply() {
            if(!this.comment.trim()) {
                this.$message('请输入回复内容！');
                return;
            }
            this.$post('api.php/User/commentReply',{
                token: this.$getToken(),
                comment_id: this.data.id,
                content: this.comment
            }).then(res => {

                if(res.status == 1) {
                    this.$message.success(res.info);
                    this.is_reply = false;
                    let obj = {
                        content: this.comment || '',
                        head_pic: this.$getUserinfo().head_pic,
                        nick_name: this.$getUserinfo().nick_name || this.$getUserinfo().mobile
                    }
                    this.reply.unshift(obj);
                    this.comment = '';
                    // this.$parent.initCommentList();
                }else {
                    this.$message.info(res.info);
                }
            })
        }
    }
}
